// extracted by mini-css-extract-plugin
module.exports = {"overlay":"Modal_overlay__1TgzI","modal":"Modal_modal__1vwov"};